import { API_URL } from "../config";

const PAGE_LIMIT = 200;
const MAX_PAGES = 50;
const INVALID_PAYLOAD_ERROR = "Respuesta de usuarios no válida";
const NETWORK_ERROR = "Error de conexión al obtener usuarios";

/**
 * @param {unknown} parsed
 * @returns {Array<Record<string, unknown>>}
 */
function parseUsersBatch(parsed) {
  if (!Array.isArray(parsed)) {
    throw new Error("Carga inválida: se esperaba un arreglo");
  }
  return parsed;
}

/**
 * Loads all tenant users for director control center (paginated API).
 *
 * @param {{ credentials?: RequestCredentials }} [options]
 * @returns {Promise<{ users: Array<Record<string, unknown>>; error: string | null }>}
 */
export async function fetchAllStaffUsers(options = {}) {
  const credentials = options.credentials ?? "include";
  const collected = [];

  for (let page = 1; page <= MAX_PAGES; page += 1) {
    let res;
    let rawBody;
    try {
      res = await fetch(`${API_URL}/usuarios?page=${page}&limit=${PAGE_LIMIT}`, {
        method: "GET",
        credentials,
      });
      rawBody = await res.text();
    } catch (err) {
      const message =
        err instanceof Error && err.message.trim() !== "" ? err.message : NETWORK_ERROR;
      return { users: [], error: message };
    }

    if (!res.ok) {
      let message = "Error al obtener usuarios";
      if (rawBody.trim() !== "") {
        try {
          const parsed = JSON.parse(rawBody);
          if (typeof parsed?.error === "string" && parsed.error.trim()) {
            message = parsed.error;
          }
        } catch {
          /* ignore parse error */
        }
      }
      return { users: [], error: message };
    }

    let batch = [];
    if (rawBody.trim() !== "") {
      try {
        const parsed = JSON.parse(rawBody);
        batch = parseUsersBatch(parsed);
      } catch {
        return { users: [], error: INVALID_PAYLOAD_ERROR };
      }
    }

    if (batch.length === 0) {
      break;
    }
    collected.push(...batch);
    if (batch.length < PAGE_LIMIT) {
      break;
    }
  }

  return { users: collected, error: null };
}
